"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewButtons = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/*
 * ViewButtons.tsx
 * Author: fwunderlich
 * Date: 28.02.2022
 *
 * Copyright: DMT GmbH & Co. KG
 */
const react_1 = __importStar(require("react"));
const button_1 = require("primereact/button");
const menu_1 = require("primereact/menu");
const ViewButton_1 = require("./ViewButton");
const ViewButtonsContainer_1 = require("./ViewButtonsContainer");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const ViewButtons = (props) => {
    const ref = (0, react_1.useRef)(null);
    const menu = (0, react_1.useRef)(null);
    const [addEvent, setAddEvent] = (0, react_1.useState)(true);
    // Anzahl der Buttons die nebeneinander gerendert werden sollen
    const [displayButtons, setDisplayButtons] = (0, react_1.useState)(-1);
    const [width, setWidth] = (0, react_1.useState)(0);
    const [collapsedItems, setCollapsedItems] = (0, react_1.useState)([]);
    const resizeEvent = () => {
        if (ref && ref.current) {
            // console.log('resize')
            setWidth(ref.current.offsetWidth);
            setDisplayButtons(-1);
        }
    };
    (0, react_1.useEffect)(() => {
        if ((props.preventShrink && props.preventShrink !== true) || props.preventShrink == undefined) {
            setWidth(0);
            // console.log('length', ref, ref.current.getElementsByClassName('testing').length);
            if (ref && ref.current && ref.current.getElementsByClassName('testing').length > 0) {
                setAddEvent(false);
                // console.log('ref changed', ref.current)
                window.addEventListener('resize', resizeEvent);
                resizeEvent();
                return () => {
                    window.removeEventListener('resize', resizeEvent);
                    setDisplayButtons(-1);
                };
            }
        }
    }, [(ref.current && ref.current.getElementsByClassName('testing'))]);
    (0, react_1.useEffect)(() => {
        if (!addEvent) {
            // console.log('update');
            updateButtons();
        }
    }, [width, props.rerender, props.items]);
    const updateButtons = () => {
        if (ref && ref.current) {
            const buttons = ref.current.getElementsByClassName('testing');
            let buttonsWidth = 0;
            let displayButtons = 0;
            const collapsedItems = [];
            const items = [];
            for (let i = 0; i < props.items.length; i++) {
                const item = props.items[i];
                let icon = item.icon;
                if (item.icon && typeof item.icon !== 'string')
                    icon = (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { className: 'sidebar-icon mr-2', icon: item.icon }, 'icon' + i);
                items.push({ label: item.label, icon: icon, command: item.onClick, disabled: item.disabled, visible: item.visible });
            }
            for (let i = 0; i < buttons.length; i++) {
                const button = buttons[i];
                button.style.display = 'block';
                buttonsWidth += button.offsetWidth + 50;
                if (buttonsWidth < width) {
                    displayButtons++;
                }
                else {
                    collapsedItems.push(items[i]);
                }
                button.style.display = 'none';
            }
            setDisplayButtons(displayButtons);
            setCollapsedItems(collapsedItems);
        }
    };
    // Lokale Zählervariable, die nur hochgezählt wird, wenn der jeweilige Button visible ist
    let _index = 0;
    return ((0, jsx_runtime_1.jsxs)(ViewButtonsContainer_1.ViewButtonsContainer, Object.assign({ innerRef: ref, flex: true }, { children: [props.items.map((item, index) => {
                return ((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: item.visible &&
                        (0, jsx_runtime_1.jsx)(ViewButton_1.ViewButton, { className: item.className + ' testing', style: { 'display': 'none' }, label: item.label, submit: item.submit, onClick: item.onClick, icon: item.icon, disabled: item.disabled }, 'butt_' + index) }, 'butt_' + index));
            }), props.items.map((item, index) => {
                if (displayButtons === -1 || _index < displayButtons) {
                    if (item.visible)
                        _index++;
                    return ((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: item.visible &&
                            (0, jsx_runtime_1.jsx)(ViewButton_1.ViewButton, { className: item.className, label: item.label, submit: item.submit, onClick: item.onClick, icon: item.icon, disabled: item.disabled }, 'butt_' + index) }, 'butt_' + index));
                }
            }), collapsedItems.length > 0 &&
                (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'col-fixed pr-0' }, { children: [(0, jsx_runtime_1.jsx)(menu_1.Menu, { popup: true, ref: menu, model: [{ label: '', items: collapsedItems }], style: { 'minWidth': '200px' } }), (0, jsx_runtime_1.jsxs)(button_1.Button, Object.assign({ className: 'p-button-outlined', style: { height: '35px' }, onClick: (event) => {
                                if (menu.current) {
                                    menu.current.toggle(event);
                                }
                            } }, { children: [props.title, (0, jsx_runtime_1.jsx)("i", { className: 'pi pi-angle-down' })] }))] }))] })));
};
exports.ViewButtons = ViewButtons;
